import { Position } from "geojson";

import { GaiaMapMarker } from "~/modules/map/components/GaiaMapMarker";
import { IconFieldworker } from "~/modules/plannerV2/components/IconFieldworker";
import { IconFieldworkerVariant } from "~/modules/plannerV2/components/IconFieldworker/iconFieldworkerVariants";

type GaiaMapMarkerFieldworkerLoadingProps = {
    coordinates: Position;
    variant?: IconFieldworkerVariant;
};

export function GaiaMapMarkerFieldworkerLoading({
    coordinates,
    variant = "pickup",
}: GaiaMapMarkerFieldworkerLoadingProps) {
    return (
        <GaiaMapMarker coordinates={coordinates} offset={[-20, -20]}>
            <IconFieldworker variant={variant} loading={true} />
        </GaiaMapMarker>
    );
}
